import { combine, createStore, sample } from 'effector'
import { routes } from '@/app/routing/router'
import { changeNavVisibilityFx, changeTabFx, smoothNavbarVisibilityFx, toggleScrollAllowanceFx } from './effects'
import {
  changeBuyKeysModalVisible,
  changeShopTab,
  changeSocialTab,
  delayedPathUpdate,
  innerWidthChangeEvent,
} from './events'
// import { postCountClick } from '@/shared/api'
import { postCountClick } from '../analytics/api'
import { $userToken } from '../user'
import { PlatformVariant } from '../platforms/types'
import { AnalyticsEvents } from '../analytics'
import { goToMain, goToShop, goToSocial, goToTasks, goToUnifiedProfile } from '@/app/routing/events'
import { UrlPathToTab } from './types/types'

export const $currentTab = createStore<number>(0).on(changeTabFx.doneData, (_, data) => {
  return data
})

sample({
  clock: [goToMain, goToShop, goToUnifiedProfile, goToSocial, goToTasks],
  fn: () => null,
  target: delayedPathUpdate,
})

delayedPathUpdate.watch(() => {
  setTimeout(() => changeTabFx(UrlPathToTab[window.location.pathname as keyof typeof UrlPathToTab] || 0), 0)
})

export const $scrollAllowed = createStore<boolean>(true).on(toggleScrollAllowanceFx.doneData, (_, data) => {
  return data
})

export const $isNavVisible = createStore<boolean>(false).on(changeNavVisibilityFx.doneData, (_, data) => {
  return data
})

export const $isNavSmoothVisible = createStore<boolean>(true).on(smoothNavbarVisibilityFx.doneData, (_, data) => {
  return data
})

export const $innerWidth = createStore<number>(window.innerWidth).on(innerWidthChangeEvent, (_, data) => {
  return data
})

export const $isBuyKeysModalVisible = createStore<boolean>(false).on(changeBuyKeysModalVisible, (_, data) => {
  return data
})

export const $newsQuery = routes.news.$query.map((query) => query.variant || 'primary')
export const $caseQuery = routes.case.$query.map((query) => query.id)
export const $dailyBonusQuery = routes.dailyBonus.$query.map((query) => query.variant)
export const $connectPlatformQuery = routes.connectPlatform.$query.map((query) => query.platform)
export const $doubleConnectionQuery = routes.doubleConnection.$query.map((query) => query.platform as PlatformVariant)
export const $externalUserTid = routes.externalUnifiedProfile.$query.map((query) => query.tid)
export const $xTgamedId = routes.externalUnifiedProfile.$query.map((query) => query.gamed_id)
export const $fromSocialTab = routes.externalUnifiedProfile.$query.map((query) => query.fromSocialTab)
export const $egsUpdating = routes.epicProfile.$query.map((query) => query.updating)
export const $tasksTab = routes.tasks.$query.map((query) => query.tab as string)

export const $shopTab = createStore<number>(1).on(changeShopTab, (_, tab) => tab)

sample({
  source: combine({
    token: $userToken,
    tab: $shopTab,
  }),
  clock: $shopTab.updates,
  fn: ({ token, tab }) => {
    if (token && tab == 2) {
      postCountClick(token, AnalyticsEvents.BUY_MORE_KEYS)
    }
  },
})

sample({
  clock: routes.shop.$query,
  fn: (query) => Number(query.tab) || 1,
  target: changeShopTab,
})

export const $socialTab = createStore<number>(2).on(changeSocialTab, (_, tab) => tab)

sample({
  clock: routes.social.$query,
  fn: (query) => Number(query.tab),
  target: changeSocialTab,
})

export const $transactionHash = routes.transactionStatus.$query.map((query) => query.hash as string)
